import React from 'react';
import './CSS/policy.css';

const TermsConditions = () => {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>TERMS & CONDITIONS – Sri Sairam Advertising</h1>
                <p className="effective-date">Effective Date: 23 April 2026</p>
                
                <p>
                    Welcome to Sri Sairam Advertising, Chennai, Tamil Nadu, India. By accessing our website, contacting us, or using any of our services, you agree to comply with and be bound by the following Terms & Conditions. If you do not agree with any part of these Terms, please do not use our website or services.
                </p>

                <hr />

                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By using our website, submitting an enquiry, contacting us by phone, WhatsApp, email, or booking any service, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>2. Services</h2>
                    <p>Sri Sairam Advertising provides services including:</p>
                    <ul>
                        <li>Newspaper advertisements</li>
                        <li>Classified advertisements (Name Change, Matrimonial, Legal, Obituary, Property, Recruitment, etc.)</li>
                        <li>Digital advertising on platforms such as Google, Facebook, and Instagram</li>
                        <li>Ad design and creative services</li>
                        <li>Bulk SMS and WhatsApp marketing services</li>
                    </ul>
                    <p>All services are subject to availability, publisher approval, third-party platform policies, and applicable laws.</p>
                </section>

                <hr />

                <section>
                    <h2>3. Booking and Confirmation</h2>
                    <p>
                        Services will be processed only after confirmation and receipt of all required details, documents, approvals, and payment. Clients must provide accurate, complete, and timely information. Urgent or deadline-based requests must be clearly communicated in advance and will be handled subject to operational feasibility.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>4. Payment Terms</h2>
                    <p>
                        Full payment is generally required before ad release, newspaper booking, or campaign activation. In certain cases, partial advance payment may be accepted at the sole discretion of Sri Sairam Advertising. Any delay in payment may result in delay, suspension, non-processing, or cancellation of services.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>5. Client Responsibility</h2>
                    <p>The client is solely responsible for:</p>
                    <ul>
                        <li>Accuracy of all submitted content</li>
                        <li>Compliance with applicable laws and platform policies</li>
                        <li>Obtaining required approvals or permissions</li>
                    </ul>
                    <p>Sri Sairam Advertising is not responsible for any legal or financial consequences arising from client-provided content.</p>
                </section>

                <hr />

                <section>
                    <h2>6. Ad Proof and Approval</h2>
                    <p>
                        Drafts or proofs may be shared before publication where applicable. Once approved by the client, no responsibility will be accepted for errors or later changes. If no response is received within the required time, we may proceed to avoid delays.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>7. Advertising Disclaimer</h2>
                    <p>
                        We do not guarantee leads, calls, inquiries, conversions, or sales. Campaign performance depends on external factors such as market conditions, competition, audience behavior, and platform algorithms.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>8. Third-Party Platforms</h2>
                    <p>Our services involve third-party platforms such as newspapers, Google, and Meta (Facebook/Instagram). We are not responsible for:</p>
                    <ul>
                        <li>Policy changes</li>
                        <li>Ad disapproval or restrictions</li>
                        <li>Platform errors or downtime</li>
                        <li>Performance variations</li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>9. Cancellation and Refund</h2>
                    <p>
                        All cancellations and refunds are governed by our Refund & Cancellation Policy. Clients are advised to review it before booking.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>10. Limitation of Liability</h2>
                    <p>
                        To the maximum extent permitted by law, Sri Sairam Advertising shall not be liable for any direct or indirect loss, including business loss, revenue loss, or missed opportunities. All services are provided on a best-effort basis.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>11. Website Usage</h2>
                    <p>Users agree not to:</p>
                    <ul>
                        <li>Use the website for unlawful or harmful purposes</li>
                        <li>Submit false or misleading information</li>
                        <li>Attempt to disrupt or damage the website</li>
                    </ul>
                </section>

                <hr />

                <section>
                    <h2>12. Intellectual Property</h2>
                    <p>
                        All designs, creatives, and website content remain the property of Sri Sairam Advertising unless otherwise agreed in writing. Unauthorized use is not permitted.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>13. Force Majeure</h2>
                    <p>
                        We are not responsible for delays or failures caused by events beyond our control, including technical issues, platform downtime, or government restrictions.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>14. Governing Law and Jurisdiction</h2>
                    <p>
                        These Terms are governed by the laws of India. All disputes are subject to the exclusive jurisdiction of Chennai, Tamil Nadu.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>15. Changes to Terms</h2>
                    <p>
                        We may update these Terms & Conditions at any time. Continued use of our services indicates acceptance of the updated Terms.
                    </p>
                </section>

                <hr />

                <section>
                    <h2>16. Contact Us</h2>
                    <div className="contact-info">
                        <p><strong>Sri Sairam Advertising</strong></p>
                        <p>Chennai, Tamil Nadu, India</p>
                        <p>📞 +91 9500037429</p>
                        <p>✉️ info@srisairamadvertising.com</p>
                        <p>🌐 <a href="https://srisairamadvertising.com/">https://srisairamadvertising.com/</a></p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default TermsConditions;
